// Línea del estudio. Formato: solo dígitos, con código de país y SIN "+", "-",
// espacios ni paréntesis.
export const WHATSAPP_NUMBER = "15616679611";

// Mismo número, con formato para mostrar y para enlaces tel:
export const PHONE = {
  display: "+1 (561) 667-9611",
  tel: "+15616679611",
  plain: "561-667-9611", // formato del contrato registrado
};

// Mensaje que se pre-llena al abrir el chat.
export const WHATSAPP_MESSAGE = {
  en: "Hi! I'd like to book a class at Apex Ride 🚴",
  es: "¡Hola! Quiero reservar una clase en Apex Ride 🚴",
};

export const whatsappLink = (lang = "es") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    WHATSAPP_MESSAGE[lang] || WHATSAPP_MESSAGE.es,
  )}`;

// Dirección oficial del estudio, según el contrato registrado ante el Estado de
// Florida (Health Studio). Debe coincidir con la del contrato: el aviso de
// cancelación exige que el domicilio publicado sea el mismo.
export const STUDIO = {
  addressLines: {
    en: ["6342 Forest Hill Blvd", "Greenacres, Florida 33415"],
    es: ["6342 Forest Hill Blvd", "Greenacres, Florida 33415"],
  },
  // Coordenadas del edificio. Las de OpenStreetMap para esta dirección caían
  // 171 metros al norte, sobre la calzada de Forest Hill Blvd; estas son las
  // que Google da para el número 6342, dentro del local.
  lat: 26.6497058,
  lng: -80.1435889,
};

// Razón social y nombre comercial registrados (aparecen en el contrato).
export const LEGAL_ENTITY = {
  name: "APEX RIDE BY GYA, LLC",
  dba: "APEX RIDE INDOOR CYCLING STUDIO",
};

// Mapa embebible con OpenStreetMap (sin API key ni bloqueos de iframe).
export const mapsEmbedUrl = () => {
  const { lat, lng } = STUDIO;
  const dLat = 0.008;
  const dLng = 0.012;
  const bbox = `${lng - dLng},${lat - dLat},${lng + dLng},${lat + dLat}`;
  return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat},${lng}`;
};

// El botón "Cómo llegar" abre Google Maps (link normal, no iframe).
//
// Se le manda la DIRECCIÓN, ni coordenadas ni el nombre del negocio:
//   · unas coordenadas fijas dejan al cliente donde las pusimos nosotros,
//   · y con el nombre delante Google no encuentra nada mientras la ficha del
//     negocio no exista, y entonces no lleva a ninguna parte.
// La dirección la resuelve siempre, y el día que la ficha esté publicada
// Google afina el punto él solo, sin tocar la web.
export const mapsDestination = () => STUDIO.addressLines.es.join(", ");

// Street View mirando a la ENTRADA, desde el parking de delante.
//
// La dirección 6342 le cae a Google por la parte de atrás, el callejón de
// servicio con las puertas numeradas, y esa es la foto que enseña de este
// número. Este punto está en el parking del frente mirando al este, que es
// por donde entra el cliente.
//
// Se le dan coordenadas y rumbo, no el identificador del panorama: los
// identificadores cambian cuando Google vuelve a fotografiar la calle, y las
// coordenadas siempre caen en la foto más cercana.
export const FACHADA = { lat: 26.6497058, lng: -80.1437472, rumbo: 90 };

export const streetViewUrl = () =>
  "https://www.google.com/maps/@?api=1&map_action=pano" +
  `&viewpoint=${FACHADA.lat},${FACHADA.lng}&heading=${FACHADA.rumbo}&pitch=0&fov=80`;

export const mapsDirectionsUrl = () =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(mapsDestination())}`;

// Las dos entrenadoras del estudio. Cuando haya foto, pon la URL en `photo`
// y sustituye sola al monograma, sin tocar nada más.
// `discipline` es la clave del texto en i18n (t.coach.disciplines).
export const COACHES = [
  { id: "glory", name: "Glory Rodríguez", monogram: "GR", photo: null, discipline: "spinning" },
  { id: "graciela", name: "Graciela O'Connor", monogram: "GO", photo: null, discipline: "floor" },
];

// Primera entrenadora: se usa donde solo cabe una (cabeceras compactas).
export const COACH = COACHES[0];

// Perfiles reales del estudio (los tres verificados abriéndolos en un navegador).
// El perfil de Facebook no tiene nombre de usuario: se enlaza por su ID numérico,
// que es permanente (las URLs "pfbid" que genera Facebook caducan).
export const SOCIALS = {
  instagram: "https://www.instagram.com/apexridecyclingindoor/",
  facebook: "https://www.facebook.com/profile.php?id=61593672446744",
  tiktok: "https://www.tiktok.com/@apexridecyclingin5",
};

// Correo público del estudio (el que aparece en su página de Facebook).
export const CONTACT_EMAIL = "apexridecyclingindoor@gmail.com";
